import {
    Box,
    HStack,
    Link as LinkStyle,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Table,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    useDisclosure
} from "@chakra-ui/react";
import React from "react";
import { MdFileDownload, MdSettings } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import { Loader } from "../../components/Loader";
import { Title } from "../../components/Title";
import { ApproveDoctorForm, IApproveDoctorValues } from "../../forms";
import {
    AllDoctorRequestsDocument,
    useApproveDoctorRequestAsSpecialistMutation,
    useApproveDoctorRequestMutation,
    useDeleteDoctorRequestMutation,
    useDoctorRequestQuery
} from "../../graphql";

import { formatDate, formatDateTime } from "../../utils";

const DoctorRequest: React.FC = () => {
    const history = useHistory();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { id } = useParams<{ id: string }>();
    const { data, loading } = useDoctorRequestQuery({
        variables: {
            id: parseInt(id)
        }
    });
    const request = data?.doctorRequest;

    const [approveDoctorRequest] = useApproveDoctorRequestMutation();
    const [
        approveDoctorRequestAsSpecialist
    ] = useApproveDoctorRequestAsSpecialistMutation();
    const [deleteDoctorRequest] = useDeleteDoctorRequestMutation();

    const handleApprove = async (approve: IApproveDoctorValues) => {
        if (approve.approvoAsSpeciality) {
            await approveDoctorRequestAsSpecialist({
                variables: {
                    id: request.id,
                    specialityId: parseInt(approve.specialityId)
                },
                refetchQueries: [
                    {
                        query: AllDoctorRequestsDocument
                    }
                ]
            });
        } else {
            await approveDoctorRequest({
                variables: {
                    id: request.id
                },
                refetchQueries: [
                    {
                        query: AllDoctorRequestsDocument
                    }
                ]
            });
        }

        history.push("/requests");
    };

    const handleDelete = async () => {
        await deleteDoctorRequest({
            variables: {
                id: request.id
            },
            refetchQueries: [
                {
                    query: AllDoctorRequestsDocument
                }
            ]
        });

        history.push("/requests");
    };

    return (
        <>
            <Modal
                closeOnOverlayClick={ false }
                isOpen={ isOpen }
                onClose={ onClose }
                size="xl"
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Aprovo kërkesën</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <ApproveDoctorForm onSubmit={ (approve) => handleApprove(approve) } />
                    </ModalBody>
                </ModalContent>
            </Modal>
            <Box
                borderWidth="1px"
                borderRadius="lg"
                overflow="hidden"
                p={ 2 }
                background="white"
            >
                <>
                    <Title title="Aplikime për mjek">
                        <Menu>
                            <MenuButton
                                px={ 4 }
                                py={ 2 }
                                transition="all 0.2s"
                                borderRadius="md"
                                _focus={ { boxShadow: "outline" } }
                            >
                                <MdSettings />
                            </MenuButton>
                            <MenuList>
                                <MenuItem onClick={ () => onOpen() }>Aprovo</MenuItem>
                                <MenuItem onClick={ () => handleDelete() }>Fshi</MenuItem>
                            </MenuList>
                        </Menu>
                    </Title>

                    { loading ? (
                        <Loader />
                    ) : (
                        <Table variant="simple">
                            <Thead>
                                <Tr>
                                    <Th isNumeric width="40%"></Th>
                                    <Th width="50%"></Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                <Tr>
                                    <Td isNumeric>Emri</Td>
                                    <Td>{ request.name }</Td>
                                </Tr>
                                <Tr>
                                    <Td isNumeric>Mbiemri</Td>
                                    <Td>{ request.lastname }</Td>
                                </Tr>
                                <Tr>
                                    <Td isNumeric>Datëlindja</Td>
                                    <Td>{ formatDate(request.birthday) }</Td>
                                </Tr>
                                <Tr>
                                    <Td isNumeric>Gjinia</Td>
                                    <Td>{ request.sex }</Td>
                                </Tr>
                                <Tr>
                                    <Td isNumeric>Telefoni</Td>
                                    <Td>{ request.phoneNumber }</Td>
                                </Tr>
                                <Tr>
                                    <Td isNumeric>E-mail</Td>
                                    <Td>{ request.email }</Td>
                                </Tr>
                                <Tr>
                                    <Td isNumeric>Shteti</Td>
                                    <Td>{ request.country.name }</Td>
                                </Tr>
                                <Tr>
                                    <Td isNumeric>Qyteti</Td>
                                    <Td>{ request.city.name }</Td>
                                </Tr>
                                <Tr>
                                    <Td isNumeric>Qëndra shëndetsore</Td>
                                    <Td>{ request.healthCenter.name }</Td>
                                </Tr>
                                <Tr>
                                    <Td isNumeric>Numri i liçensës</Td>
                                    <Td>{ request.licenceNumber }</Td>
                                </Tr>
                                <Tr>
                                    <Td isNumeric>CV</Td>
                                    <Td>
                                        <LinkStyle>
                                            <a href={ request.cvUrl } target="_blank">
                                                <HStack spacing="24px">
                                                    <Box w="5px">
                                                        <MdFileDownload></MdFileDownload>
                                                    </Box>
                                                    <Box w="170px">Shkarko</Box>
                                                </HStack>
                                            </a>
                                        </LinkStyle>
                                    </Td>
                                </Tr>
                                <Tr>
                                    <Td isNumeric>Data e aplikimit</Td>
                                    <Td>{ formatDate(request.createdAt) }</Td>
                                </Tr>
                            </Tbody>
                        </Table>
                    ) }
                </>
            </Box>
        </>
    );
};

export default DoctorRequest;
